import "@/App.css";
import "./lib/axiosInstance"; // Sets up global axios with auth refresh + cookies
import "./lib/offlineQueue"; // Sets up offline queue + retry on reconnection
import "./lib/readOnlyMode"; // Mobile read-only for non-admins
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { PermissionsProvider } from "./contexts/PermissionsContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppLayout } from "./components/layout/AppLayout";
import { OfflineBanner } from "./components/OfflineBanner";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AdminPage } from "./pages/AdminPage";
import { AdminSettingsPage } from "./pages/AdminSettingsPage";
import StatistiquesPage from "./pages/StatistiquesPage";
import { AdminArticlesPage } from "./pages/AdminArticlesPage";
import { UsersManagementPage } from "./pages/UsersManagementPage";
import AdminPermissionsPage from "./pages/AdminPermissionsPage";
import { ProspectsPage } from "./pages/ProspectsPage";
import { CalendrierPage } from "./pages/CalendrierPage";
import { PlanifierVisitePage } from "./pages/PlanifierVisitePage";
import { InventairesPage } from "./pages/InventairesPage";
import { DevisPage } from "./pages/DevisPage";
import DevisDossierPage from "./pages/DevisDossierPage";
import DevisAEnvoyerPage from "./pages/DevisAEnvoyerPage";
import RelancesPage from "./pages/RelancesPage";
import InteressesPage from "./pages/InteressesPage";
import ProblemesPage from "./pages/ProblemesPage";
import ClientsPage from "./pages/ClientsPage";
import ClientDetailPage from "./pages/ClientDetailPage";
import CalendrierPrestationPage from "./pages/CalendrierPrestationPage";
import AotPage from "./pages/AotPage";
import MonteMeublePage from "./pages/MonteMeublePage";
import GardeMeublePage from "./pages/GardeMeublePage";
import FacturationPage from "./pages/FacturationPage";
import FacturationDetailPage from "./pages/FacturationDetailPage";
import FacturationRecapPage from "./pages/FacturationRecapPage";
import CarteGroupagePage from "./pages/CarteGroupagePage";
import TarifAotPage from "./pages/TarifAotPage";
import ExploitationPage from "./pages/ExploitationPage";
import EspaceDemenageursPage from "./pages/EspaceDemenageursPage";
import EspaceDemenageursFormPage from "./pages/EspaceDemenageursFormPage";
import TacheExternePage from "./pages/TacheExternePage";
import PointageDemenageursPage from "./pages/PointageDemenageursPage";
import DemenageurDetailPage from "./pages/DemenageurDetailPage";
import TachesPage from "./pages/TachesPage";
import TachesAEffectuerPage from "./pages/TachesAEffectuerPage";
import RecherchePage from "./pages/RecherchePage";
import VisitesAReprogrammerPage from "./pages/VisitesAReprogrammerPage";
import VisitesListePage from "./pages/VisitesListePage";
import CorbeillePage from "./pages/CorbeillePage";
import AppelsPage from "./pages/AppelsPage";
import VisitesRetardPage from "./pages/VisitesRetardPage";
import { Toaster } from "./components/ui/sonner";

function App() {
    return (
        <AuthProvider>
            <PermissionsProvider>
            <BrowserRouter>
                <OfflineBanner />
                <Routes>
                    {/* Public Routes */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/espace-demenageurs/form" element={<EspaceDemenageursFormPage />} />
                    <Route path="/tache-externe/:token" element={<TacheExternePage />} />

                    {/* Protected Routes */}
                    <Route
                        element={
                            <ProtectedRoute>
                                <AppLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route path="/" element={<DashboardPage />} />
                        <Route path="/prospects" element={<ProspectsPage />} />
                        <Route path="/calendrier" element={<CalendrierPage />} />
                        <Route path="/planifier" element={<PlanifierVisitePage />} />
                <Route path="/inventaires" element={<InventairesPage />} />
                        <Route path="/devis" element={<DevisPage />} />
                        <Route path="/devis-a-envoyer" element={<DevisAEnvoyerPage />} />
                        <Route path="/relances" element={<RelancesPage />} />
                        <Route path="/interesses" element={<InteressesPage />} />
                        <Route path="/problemes" element={<ProblemesPage />} />
                        <Route path="/taches-a-effectuer" element={<TachesAEffectuerPage />} />
                        <Route path="/recherche" element={<RecherchePage />} />
                        <Route path="/appels" element={<AppelsPage />} />
                        <Route path="/visites-retard" element={<VisitesRetardPage />} />
                        <Route path="/devis/:inventaireId" element={<DevisDossierPage />} />
                        <Route path="/clients" element={<ClientsPage />} />
                        <Route path="/clients/:clientId" element={<ClientDetailPage />} />
                        <Route path="/calendrier-prestation" element={<CalendrierPrestationPage />} />
                        <Route path="/aot" element={<AotPage />} />
                        <Route path="/monte-meuble" element={<MonteMeublePage />} />
                        <Route path="/garde-meuble" element={<GardeMeublePage />} />
                        <Route path="/facturation" element={<FacturationPage />} />
                        <Route path="/facturation/recap" element={<FacturationRecapPage />} />
                        <Route path="/facturation/:factureId" element={<FacturationDetailPage />} />
                        <Route path="/carte-groupage" element={<CarteGroupagePage />} />
                        <Route path="/tarif-aot" element={<TarifAotPage />} />
                        <Route path="/exploitation" element={<ExploitationPage />} />
                        <Route path="/exploitation/espace-demenageurs" element={<EspaceDemenageursPage />} />
                        <Route path="/exploitation/pointage-demenageurs" element={<PointageDemenageursPage />} />
                        <Route path="/exploitation/pointage-demenageurs/demenageur/:id" element={<DemenageurDetailPage />} />
                        <Route path="/taches" element={<TachesPage />} />
                        <Route path="/visites-a-reprogrammer" element={<VisitesAReprogrammerPage />} />
                        <Route path="/visites-liste" element={<VisitesListePage />} />
                        <Route path="/admin/corbeille" element={<CorbeillePage />} />
                        <Route path="/statistiques" element={<StatistiquesPage />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="/admin/users" element={<UsersManagementPage />} />
                        <Route path="/admin/permissions" element={<AdminPermissionsPage />} />
                        <Route path="/admin/settings" element={<AdminSettingsPage />} />
                        <Route path="/admin/articles" element={<AdminArticlesPage />} />
                    </Route>

                    {/* Catch all - redirect to dashboard */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster />
            </PermissionsProvider>
        </AuthProvider>
    );
}

export default App;
